<!-- @format -->

<div class="row">
  <div class="col-12" [ngClass]="{ 'col-md-10': loggedIn }">
    <div class="row course-unit-heading">
      <div class="results-name col-12">
        <div class="title-box" data-cy="course-unit-info-link">
          <a href="/student/courseunit/{{ result.id }}" data-cy="course-unit-info-link">
            <h3 class="courseunit-title">
              <sis-mark-string [target]="result.name" [query]="term" /> ({{ result.credits | creditRange: "TEXT" }})
            </h3>
          </a>
          <span class="courseunit-code"><sis-mark-string [target]="result.code" [query]="term" /></span>
        </div>
        @if (matchingOtherLang) {
          <div class="language-match">
            <span class="language-match-title" translate>SEARCH_LANGUAGE_MATCH</span>
            <span>{{ " " + result.nameMatch }}</span>
          </div>
        }
      </div>
    </div>
    <div class="row">
      @if (result.tweetText) {
        <div class="col-12 tweet-text">
          <p>{{ result.tweetText }}</p>
        </div>
      }
      <div class="col-12 col-md-5">
        <div class="tiny-static-form-group">
          <span class="label colon" translate>SEARCH_RESULT.COOPERATION_NETWORK</span>
          @for (cooperationNetworkId of result.cooperationNetworkIds; track cooperationNetworkId; let j = $index) {
            <span class="value">
              {{ cooperationNetworkId | cooperationNetwork | async | entityName | localizedString }}
              @if (result.cooperationNetworkIds.length - 1 !== j) {
                <span>,</span>
              }
            </span>
          }
        </div>
        <div class="tiny-static-form-group">
          <span class="label colon" translate>SEARCH_RESULT.TEACHING_LANGUAGES</span>
          @if (curLangCodeUrns.length === 0) {
            <span class="value" translate>SEARCH_RESULT.NO_INFO</span>
          }
          @for (urn of curLangCodeUrns; track urn; let j = $index) {
            <span class="value">
              {{ urn | codeLocalizedName | async }}
              @if (curLangCodeUrns.length - 1 !== j) {
                <span>,</span>
              }
            </span>
          }
        </div>
      </div>
      <div class="col-12 col-md-5">
        <div class="tiny-static-form-group">
          <span class="label colon" translate>SEARCH_RESULT.OFFERING_UNIVERSITY</span>
          @for (universityOrgId of result.universityOrgIds; track universityOrgId; let j = $index) {
            <span class="value">
              {{ (universityOrgId | organisation | async)?.name | localizedString }}
              @if (result.universityOrgIds.length - 1 !== j) {
                <span>,</span>
              }
            </span>
          }
        </div>
      </div>
    </div>
  </div>
  @if (loggedIn) {
    <div class="col-12 col-md-2">
      <div class="course-cart-actions float-md-right" aria-live="polite">
        @if (!isInCart) {
          <sis-button
            [naked]="true"
            size="sm"
            (clicked)="addToCart()"
            dataCy="add-to-course-cart"
            [ariaLabel]="('ARIA_LABEL.ADD_TO_CART' | translate) + ' ' + (result.name | plainText)">
            <sis-icon icon="list-add"></sis-icon>
            <span translate>ADD_TO_CART</span>
          </sis-button>
        }
        @if (isInCart) {
          <sis-button
            [naked]="true"
            size="sm"
            variant="secondary"
            (clicked)="removeFromCart()"
            dataCy="remove-from-course-cart"
            [ariaLabel]="('ARIA_LABEL.REMOVE_FROM_CART' | translate) + ' ' + (result.name | plainText)">
            <sis-icon icon="list-minus"></sis-icon>
            <span translate>REMOVE_FROM_CART</span>
          </sis-button>
        }
      </div>
    </div>
  }
</div>
